<template lang="pug">
  div
    el-row
      el-col
        h3.title Busbud Transferencias Pendientes - {{ selectedCountryName }}
      el-col
        el-form(:inline="true" label-position="top" size="mini")
          el-form-item(label="País:")
            select-input(:options="countries" :attribute="search" modelKey="country")
          el-form-item(label="Operadores:")
            select-input(
              :options="filteredBBConciliables"
              :attribute="search"
              modelKey="operators"
              :multiple="true"
            )
          el-form-item(label="Por Día de transferencia:")
            date-input(:inputModel="search")
          el-form-item.filters__buttons-wrapper
            el-button(
              type="primary"
              icon="el-icon-search"
              @click.prevent="fetchBBPendingTransfers()"
            ) FILTRAR
    el-row
      el-col
        data-table(
          :headers="headers"
          :items="items"
          :summaries="summaries"
          :height="500"
          :shownSummary="true"
          :loading="loading"
          :shownEdit="false"
          @cellClickEvent="handleCellClick"
          refTable="BBpendingTransfersTable"
          :stripe="false"
          :shownActions="false"
          :shownSelection="false"
          @select="handleSelectionChange"
        )
</template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import DataTable from '@/components/tables/DataTable.vue';
import DateInput from '@/components/forms/inputs/DateInput.vue';

// eslint-disable-next-line import/no-cycle
import FinanceApi from '@/services/apiService';
import DataService from '@/services/dataService';
import DateService from '@/services/dateService';

// eslint-disable-next-line import/no-cycle
import BBconciliables from '@/mixins/BBconciliables';
import pendingTransfers from '@/mixins/pendingTransfers';

export default {
  name: 'BBPendingTransfers',
  components: {
    SelectInput, DataTable, DateInput,
  },
  mixins: [
    BBconciliables, pendingTransfers,
  ],
  data() {
    return {
      items: [],
      summaries: [],
      search: {
        country: 'CL',
        operators: [],
        date: DateService.getDate(),
      },
      operators: [],
      selectedCountry: null,
      loading: false,
      submitLoading: false,
      channelMessage: '',
    };
  },
  beforeMount() {
    this.fetchBBPendingTransfers();
  },
  methods: {
    fetchBBPendingTransfers() {
      this.loading = true;

      FinanceApi.get_bb_pending_transfers(this.search).then((data) => {
        this.items = data.body.pending_transfers.map((pendingTransfer) => ({
          ...pendingTransfer,
          disabled: true,
        }));
        this.loading = false;
        this.summaries = data.body.summary;
        const emptyBankData = data.body.empty_bank_data;
        if (emptyBankData.length > 0) {
          const emptyBankDataList = emptyBankData.join(', ');
          this.$notify.warning({ title: '¡Cuidado!', message: `Hay operadores o grupos sin datos bancarios: ${emptyBankDataList}` });
        }
      }).catch((exception) => {
        this.$notify.error({ title: 'Error', message: exception.body.message });
        this.loading = false;
      });
      this.selectedCountry = this.search.country;
    },
    startSubmitLoading() {
      this.submitLoading = true;
    },
    stopSubmitLoading() {
      this.submitLoading = false;
    },
  },
  computed: {
    headers() {
      return [
        { key: 'operator', label: 'Operador' },
        { key: 'national_id', label: 'Rut' },
        { key: 'holder', label: 'Titular de la cuenta' },
        { key: 'bank_name', label: 'Banco' },
        { key: 'number', label: 'Numero de Cuenta' },
        { key: 'dates_to_transfer', label: 'Fechas a transferir' },
        {
          key: 'to_transfer', label: 'A Transferir', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'pendings', label: 'Pendientes', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'discounts', label: 'Descuentos', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'calculated_to_transfer', label: 'A Transferir con descuentos y pendientes', type: 'currency', country: this.selectedCountry,
        },
        {
          key: 'transfer_amount', label: 'Transferido', type: 'currency', country: this.selectedCountry,
        },
      ];
    },
    countries() {
      return DataService.get_countries();
    },
    selectedCountryName() {
      return this.countries.find((country) => country.key === this.selectedCountry).value;
    },
  },
};
</script>
